export default "__VITE_ASSET__NNLuP8Gb__"